$(document).ready(function() {
    /**
     * Le niveau 2 : Mes services > Loisirs
     */
    const sousMenuNiv2 = $('.tematik_sous_menu ul:first-child > li.nav-path-selected > ul > li.nav-path-selected > a');
    const sousMenuConteneur = $('.tematik_sous_menu ul:first-child > li.nav-path-selected > ul > li > ul');
    sousMenuConteneur.css('height', sousMenuConteneur.height());

    sousMenuNiv2.on('click', function(event) {
        event.preventDefault();
        $(this).toggleClass('collapsed');
        // Le conteneur du niveau 3
        sousMenuConteneur.toggleClass('collapsed');
    })
})